import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { CompaniesProvider } from '../../providers/companies/companies.provider';
import { Sucursal } from '../../services/lbsdk/models/Sucursal';
import { ControlEmpresaPage } from './control-empresa/control-empresa'
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Empresa, EmpresaApi } from '../../services/lbsdk';
import { AuthService } from '../../services/auth/auth.service';

@IonicPage()
@Component({
  selector: 'page-empresas',
  templateUrl: 'empresas.html',
})
export class EmpresasPage {

  companies: Empresa[] = [];
  paginationInfo = {
    page: 0,
    pageSize: 0,
    rowCount: 0,
    pageCount: 0
  }
  sortReverse: boolean = false;
  sortField: string = 'razonSocial';
  sortType: string = 'ASC';
  searchKey: string = '';
  sucursal:Sucursal[] = [];
  idempresas: String []= [];
  admin;
  superAdmin;

  private subject: Subject<string> = new Subject<string>();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private companiesProvider: CompaniesProvider,
    private loading: LoadingController, private empresaApi: EmpresaApi,private authService: AuthService
  ) {
  }
  ionViewDidLoad() {

    // Muestra botones de editar o agregar usuarios si es admin o superadmin
    this.superAdmin = this.authService.isSuperAdministrador();
    this.admin = this.authService.isAdministrador();
  }

  ionViewDidEnter() {

    // console.log(data);
    let loader = this.loading.create({
      content: 'Aguarde se están obteniendo los datos...'
    });

    
    loader.present();
    //   this.companiesProvider.count("")

    this.subject.pipe(
      debounceTime(200))
      .subscribe(searchTextValue => {
        this.searchKey = searchTextValue;
        this.handleSearch(searchTextValue);
      });
    // SI ES SUPER ADMINISTRADOR TRAIGO TODAS
    if (this.authService.isSuperAdministrador()) {

      this.empresaApi.count()
      .subscribe(res => {

        this.paginationInfo.rowCount = res.count;
        this.paginationInfo.pageSize = 5;
        this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize));
        this.paginationInfo.page = 1;

        
        this.empresaApi.find({ limit: 5, order: `${this.sortField} ${this.sortType}` })
          .subscribe((companies: Empresa[]) => {
            this.companies = companies;
            loader.dismiss();
          }, error => loader.dismiss)

        this.subject.pipe(
          debounceTime(200))  
          .subscribe(searchTextValue => {
            this.searchKey = searchTextValue;
            this.handleSearch(searchTextValue);
          });
      }, error => loader.dismiss)




    }
    // SI NO ES SUPER ADMINISTRADOR TRAIGO LAS EMPRESAS ASOCIADAS
    else {
      let aux = JSON.parse(sessionStorage.getItem('userData'));
      
      // BUSCO LOS IDEMPRESA DE TODAS LAS SUCURSALES ASOCIADAS AL USUARIO
      for (let i = 0; i < aux.sucursales.length; i++) {
        const ayuda: String = aux.sucursales[i].idempresa

        
      this.idempresas.push(ayuda)
        
      }
      // BORRO LOS REPETIDOS
      let result =  this.idempresas.filter((item,index)=>{
        return  this.idempresas.indexOf(item) === index;

      })

        console.log(result);
      
      
      // BUSCO LAS EMPRESAS USANDO EL ARRAY DE LOS IDEMPRESAS DE LAS SUCURSALES
        this.empresaApi.find({ where: { idEmpresa: { inq: result } }})
          .subscribe(res => {

            console.log('--------------',res);
            
            console.log('cant empresas' + res.length);

            this.paginationInfo.rowCount = res.length
            this.paginationInfo.pageSize = 5;;
            this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize));
            this.paginationInfo.page = 1;

            this.empresaApi.find({where: { idEmpresa: { inq: result } }, limit: 5, order: `${this.sortField} ${this.sortType}` })
              .subscribe((Empresa: Empresa[]) => {

                this.companies = Empresa;

                loader.dismiss();

              }

      
          , error => loader.dismiss)
        }, error => loader.dismiss)
      }
  }
    
  onKeyUp(event) {
    
    if (event.target.value.toString().length > 3){
      const searchKey = event.target.value;
      this.subject.next(searchKey);
    }
    
    if (event.target.value.toString().length == 0){
      const searchKey = event.target.value;
      this.subject.next(searchKey);
    }

  }

  addNew() {
    let newCompany: Empresa = new Empresa ();
    this.navCtrl.push(ControlEmpresaPage, { data: newCompany })
  }

  update(company: Empresa) {
   
    this.navCtrl.push(ControlEmpresaPage, { data: company });
  }


  setOrder(field: string) {
    this.sortField = field;
    this.sortReverse = !this.sortReverse;
    this.sortType = this.sortReverse ? ' DESC' : ' ASC';
    this.handleSearch(this.searchKey);
  }

  //#region Paginador

  changePage(valor) {
    
    //SI ES SUPERADMINISTADOR MUESTRA TODAS AL CAMBIAR 
    if (this.authService.isSuperAdministrador()) {
      let loader = this.loading.create({
        content: 'Aguarde se están obteniendo los datos...'
      });
      loader.present();
      this.paginationInfo.page = valor;
      let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page
      let skipElements = pageAux * this.paginationInfo.pageSize - 5;
  
      if (skipElements < 0) skipElements = 0;
  
      let filtro = {}
      filtro = {
        where: {
          or: [
            { name: { regexp: '/' + this.searchKey + '/i' } },
            { email: { regexp: '/' + this.searchKey + '/i' } }
          
          ]
        },
        skip: (skipElements), limit: 5, order: `${this.sortField} ${this.sortType}`
      }
  
     
      this.empresaApi.find(filtro)
        .subscribe((companies: Empresa[]) => {
          this.companies = companies;
          loader.dismiss();
        }, error => loader.dismiss())
    } 
    //SI NO ES SUPERADMINISTADOR MUESTRA SOLO LAS ASOCIADAS 
    else {

   

    let loader = this.loading.create({
      content: 'Aguarde se están obteniendo los datos...'
    });
    loader.present();


    this.paginationInfo.page = valor;
    let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page
    let skipElements = pageAux * this.paginationInfo.pageSize - 5;

    if (skipElements < 0) skipElements = 0;


    let aux = JSON.parse(sessionStorage.getItem('userData'));
    // BUSCO LOS IDEMPRESA DE TODAS LAS SUCURSALES ASOCIADAS AL USUARIO
    for (let i = 0; i < aux.sucursales.length; i++) {
      const ayuda: String = aux.sucursales[i].idempresa

      
     this.idempresas.push(ayuda)
      
    }
    //BORRO LOS IDEMPRESA REPETIDOS
    let result =  this.idempresas.filter((item,index)=>{
      return  this.idempresas.indexOf(item) === index;

    })
    
    let filtro = {}
    // BUSCO LAS EMPRESAS USANDO EL ARRAY DE LOS IDEMPRESAS DE LAS SUCURSALES
    filtro = {
      where: {
        and: [{
          idEmpresa: { inq: result }
        }, { razonSocial: { like: '%' + this.searchKey + '%' } }]
      },
      skip: (skipElements), limit: 5, order: `${this.sortField} ${this.sortType}`
    }

    
    this.empresaApi.find(filtro)
      .subscribe((companies: Empresa[]) => {
        this.companies = companies;
        loader.dismiss();
      }, error => loader.dismiss())
    }
  }
  //#endregion

  public handleSearch(searchKey: string) {

    //SI ES SUPERADMINISTRADOR PUEDE BUSCAR TODAS
    if (this.authService.isSuperAdministrador()) { 


      console.log(`handleSearch:  ${searchKey}`, this.paginationInfo)
    let observable
    //NEW}

    observable = this.empresaApi.count();//this.companiesProvider.count({})


    observable.subscribe(res => {
      console.log(res);
      this.paginationInfo.rowCount = res.count;
      this.paginationInfo.pageSize = 5,
        this.paginationInfo.pageCount = (this.paginationInfo.rowCount / this.paginationInfo.pageSize)
      this.paginationInfo.page = 1
      let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page

      let filtro = {}
      filtro = {
        where: {
          or: [
            {razonSocial: {like: '%' + this.searchKey + '%'} },
            {cuit: {like: '%' + this.searchKey + '%'} },
        
          ]
        },
        skip: (pageAux * this.paginationInfo.pageSize), limit: 5, order: `${this.sortField} ${this.sortType}`
      }
      console.log('filtrooooooooo',filtro);
      this.empresaApi.find(filtro)
        .subscribe((companies: any[]) => {
          this.companies = companies;
          

          if (this.searchKey.length > 3) {
          this.paginationInfo.rowCount = companies.length
          this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize))
          }
          // loader.dismiss();
        })


    }, error => console.log("error"))/*loader.dismiss()*/
    }
    //SI NO ES SUPERADMINISTRADOR PUEDE BUSCAR SOLO LAS EMPRESAS ASOCIADAS
    else {
    console.log(`handleSearch:  ${searchKey}`, this.paginationInfo)
    let observable
    //NEW}

    observable = this.empresaApi.count();


    observable.subscribe(res => {
      console.log(res);
      this.paginationInfo.rowCount = res.count;
      this.paginationInfo.pageSize = 5,
      this.paginationInfo.pageCount = (this.paginationInfo.rowCount / this.paginationInfo.pageSize)
      this.paginationInfo.page = 1
      let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page

      let aux = JSON.parse(sessionStorage.getItem('userData'));
      // BUSCO LOS IDEMPRESA DE TODAS LAS SUCURSALES ASOCIADAS AL USUARIO
      for (let i = 0; i < aux.sucursales.length; i++) {
        const ayuda: String = aux.sucursales[i].idempresa

      
        this.idempresas.push(ayuda)
        
      }
      // BORRO LOS IDEMPRESA REPETIDOS
      let result =  this.idempresas.filter((item,index)=>{
        return  this.idempresas.indexOf(item) === index;

      })

      let filtro = {}
      // BUSCO LAS EMPRESAS USANDO EL ARRAY DE LOS IDEMPRESAS DE LAS SUCURSALES
      filtro = {
        where: {
          and: [{
            idEmpresa: { inq: result }
          }, { razonSocial: { like: '%' + this.searchKey + '%' } }]
        },
          skip: (pageAux * this.paginationInfo.pageSize), limit: 5, order: `${this.sortField} ${this.sortType}`
        }

      console.log('filtrooooooooo',filtro);
      
      this.empresaApi.find(filtro).subscribe((companies: Empresa[]) => {

          
          this.paginationInfo.rowCount = companies.length
          this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize))
          this.companies = companies;
          // loader.dismiss();
        })


    }, error => console.log("error"))/*loader.dismiss()*/

  }
  }

}

export class paginationInfo {
  page: number;
  pageSize: number;
  rowCount: number;
  pageCount: number;
}




// WEBPACK FOOTER //
// ./src/pages/empresas/empresas.ts